export default __webpack_public_path__ + "static/media/PCAL.8c65280a.png";